import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'

import request from './untils/request'

import { getCookie } from './untils/tools';
Vue.prototype.getCookie = getCookie

Vue.prototype.request = request
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    const token = getCookie();
    if (!token && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }
});

if (false) {

} else {
    //http://inspectapi.zhiyanglao.cn/public/index.php?s=/admin/控制器/方法名
    //http://inspectapi.zhiyanglao.cn/index.php/general/commonapi/方法名
    //控制器 Login Institution
    Vue.prototype.baseUrl = 'https://inspectapi.zhiyanglao.cn/'
    Vue.prototype.commUrl = 'https://inspectapi.zhiyanglao.cn/Commonapi/'
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
